<template>
  <v-dialog v-model="data.dialogShow" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="gray" class="elevation-1 green lighten-2">
        <v-btn flat icon @click="data.dialogShow = false">
          <font-awesome-icon icon="arrow-left" size="2x" class="black--text" />
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-items></v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-card class="mb-2 py-1 elevation-1 green lighten-5">
          <v-layout align-start justify-start row wrap>
            <v-flex md12>
              <v-btn
                color="light-blue darken-3"
                class="elevation-1"
                :loading="isLoading"
                @click="onSave()"
              >
                <v-icon class="pr-2">save</v-icon>SAVE
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card class="mb-1 py-1 elevation-1 green lighten-5">
          <v-layout align-start justify-start row wrap>
            <v-flex md6>
              <v-alert
                class="ma-2"
                dismissible
                :value="alertValue"
                :color="alertColor"
                :icon="alertIcon"
                outline
              >{{alertMessage}}</v-alert>
            </v-flex>
          </v-layout>
          <v-layout align-start justify-start row wrap>
            <v-flex md4>
              <v-layout align-start justify-start row wrap>
                <v-flex md12 class="px-3">
                  <v-text-field
                    label="Kode"
                    v-model="code"
                    v-validate="'required'"
                    data-vv-name="code"
                    :error-messages="errors.collect('code')"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 class="px-3">
                  <v-text-field
                    label="Nama"
                    v-model="name"
                    v-validate="'required'"
                    data-vv-name="name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 class="px-3">
                  <span class="body-2">Status :</span>
                  <v-switch label="Enable" v-model="isEnabled"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md6>
              <v-layout>
                <v-flex md12>
                  <v-select v-model="tipeSelected" :items="tipeItems" label="Tipe"></v-select>
                </v-flex>
              </v-layout>
              <v-layout></v-layout>
              <v-layout>
                <v-flex md12>
                  <v-textarea v-model="description" label="Keterangan"></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
// import { quillEditor } from "vue-quill-editor";
import ApiService from "@/common/api.service";

export default {
  components: {
    // quillEditor
  },
  props: {
    data: Object
  },
  data: () => ({
    tipeItems: ["NORMAL", "KM", "HSPQ"],
    tipeSelected: "",
    isLoading: false,
    alertColor: "",
    alertIcon: "",
    alertValue: false,
    alertMessage: "",
    code: "",
    name: "",
    isEnabled: true,
    totalTime: 0,
    description: "",
    instruction: "",
    id: ""
  }),
  updated() {
    if (this.data.firstLoad === true) {
      const vm = this;
      vm.isLoading = true;
      ApiService.post("DataPackage/GetDataPackageById", {
        Id: vm.data.dataPackageId
      })
        .then(response => {
          vm.id = response.data.id;
          vm.code = response.data.code;
          vm.name = response.data.name;
          vm.isEnabled = response.data.isEnabled;
          vm.description = response.data.description;
          vm.data.firstLoad = false;
          vm.isLoading = false;
          vm.tipeSelected = response.data.tipe;
        })
        .catch(() => {
          vm.data.firstLoad = false;
          vm.isLoading = false;
        });
    }
  },
  methods: {
    onSave: function() {
      this.$validator.validate().then(valid => {        
        if (valid) {
          const vm = this;
          vm.isLoading = true;
          vm.alertValue = false;
          ApiService.post("DataPackage/UpdateDataPackage", {
            Id: vm.id,
            Code: vm.code,
            Name: vm.name,
            Description: vm.description,
            IsEnabled: vm.isEnabled,
            Tipe: vm.tipeSelected
          })
            .then(() => {
              vm.isLoading = false;
              vm.$emit("close-window");
              vm.data.dialogShow = false;
            })
            .catch(({ response }) => {
              vm.isLoading = false;
              if (response.status == 400) {
                vm.alertColor = "warning";
                vm.alertIcon = "priority_high";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              } else {
                vm.alertColor = "error";
                vm.alertIcon = "warning";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              }
            });
        }
      });
    },
    clearForm: function() {
      this.isLoading = false;
      this.alertColor = "";
      this.alertIcon = "";
      this.alertValue = false;
      this.alertMessage = "";
      this.code = "";
      this.name = "";
      this.isEnabled = true;
      this.isSubAspecMerged = false;
      this.description = "";
      this.$validator.reset();
    }
  }
};
</script>
